<i18n>
{
    "en_US": {
        "markdown-bold": "Bold",
        "markdown-italic": "Italic",
        "markdown-header": "Title",
        "markdown-link": "Insert link/url",
        "markdown-image": "Insert image",
        "markdown-table": "Insert table",
        "markdown-list-unsorted": "Insert unsorted list",
        "markdown-list-sorted": "Insert sorted list",
        "markdown-list-checked": "Insert todo list",
        "markdown-code": "Insert code",
        "markdown-quote": "Insert quote"
    },
    "fr_FR": {
        "markdown-bold": "Gras",
        "markdown-italic": "Italique",
        "markdown-header": "Titre",
        "markdown-link": "Insérer un lien/une URL",
        "markdown-image": "Insérer une image",
        "markdown-table": "Insérer un tableau",
        "markdown-list-unsorted": "Insérer une liste non-ordonnée",
        "markdown-list-sorted": "Insérer une liste ordonnée",
        "markdown-list-checked": "Insérer une todo liste",
        "markdown-code": "Insérer du code",
        "markdown-quote": "Insérer une citation"
    }
}
</i18n>

<template>
    <div class="markdown-controls-toolbar">
        <button type="button" class="btn btn-link" v-on:click="bold" v-bind:title="$t('markdown-bold')">
            <i class="fa fa-bold"></i>
        </button>
        <button type="button" class="btn btn-link" v-on:click="italic" v-bind:title="$t('markdown-italic')">
            <i class="fa fa-italic"></i>
        </button>
        <button type="button" class="btn btn-link" v-on:click="header" v-bind:title="$t('markdown-header')">
            <i class="fa fa-heading"></i>
        </button>

        <div class="separator">&nbsp;</div>

        <button type="button" class="btn btn-link" v-on:click="showMenuUpload('link')" v-bind:title="$t('markdown-link')">
            <i class="fa fa-link"></i>
        </button>
        <button type="button" class="btn btn-link" v-on:click="showMenuUpload('image')" v-bind:title="$t('markdown-image')">
            <i class="fa fa-image"></i>
        </button>
        <dropdown-table-selector v-on:click="selectedTableDimensions" v-bind:inverted="inverted" v-bind:title="$t('markdown-table')" />

        <div class="separator">&nbsp;</div>

        <button type="button" class="btn btn-link" v-on:click="listUl" v-bind:title="$t('markdown-list-unsorted')">
            <i class="fa fa-list-ul"></i>
        </button>
        <button type="button" class="btn btn-link" v-on:click="listOl" v-bind:title="$t('markdown-list-sorted')">
            <i class="fa fa-list-ol"></i>
        </button>
        <button type="button" class="btn btn-link" v-on:click="listTodo" v-bind:title="$t('markdown-list-checked')">
            <i class="fa fa-list"></i>
        </button>
        <button type="button" class="btn btn-link" v-on:click="code" v-bind:title="$t('markdown-code')">
            <i class="fa fa-code"></i>
        </button>
        <button type="button" class="btn btn-link" v-on:click="quote" v-bind:title="$t('markdown-quote')">
            <i class="fa fa-quote-left"></i>
        </button>
    </div>
</template>

<script>
    import { mapMutations } from "vuex";
    import event from "plugins/event";
    import DropdownTableSelector from "dropdowns/TableSelector";

    export default {
        name: "Toolbar",
        props: {
            inverted: Boolean
        },
        components: {
            DropdownTableSelector
        },
        methods: {
            bold: function() {
                event.$emit("markdown-insert-bold");
            },
            italic: function() {
                event.$emit("markdown-insert-italic");
            },
            header: function() {
                event.$emit("markdown-insert-header");
            },
            selectedTableDimensions: function(tableDimensions) {
                event.$emit("markdown-insert-table", tableDimensions);
            },
            table: function() {
                event.$emit("markdown-insert-table");
            },
            listUl: function() {
                event.$emit("markdown-insert-list-ul");
            },
            listOl: function() {
                event.$emit("markdown-insert-list-ol");
            },
            listTodo: function() {
                event.$emit("markdown-insert-list-todo");
            },
            code: function() {
                event.$emit("markdown-insert-code");
            },
            quote: function() {
                event.$emit("markdown-insert-quote");
            },
            ...mapMutations("application", ["showMenuUpload"])
        }
    }
</script>

<style scoped>
    .markdown-controls-toolbar {
        display: none;
        height: 56px;
        padding: 12px 18px;
        border-top: 1px solid rgb(228, 234, 236);
        transition: all 0.5s ease-in-out 0s;
        justify-content: space-between;
    }
    .separator {
        width: 2px;
        height: 30px;
        content: "";
        display: inline-block;
        vertical-align: middle;
        margin: 0px 5px;
        background: rgb(228, 234, 236);
    }
    .btn-link {
        color: rgb(163, 175, 183);
        line-height: 14px;
        margin-bottom: 0;
        margin-top: 1px;
        padding-left: 12px;
        padding-right: 12px;
    }
    .btn-link:hover {
        color: rgb(17, 17, 17);
    }

    @media screen and (max-width: 850px) {
        .markdown-controls-toolbar {
            display: -webkit-flex;
            display: flex;
        }
    }
</style>
